//Condicionos para móvil

//Condiciones para PC

import { EditorStore, useStore } from '../../store/createStore';
import StepTourPopover from '../../components/StepTourPopover/StepTourPopover';
import { useEffect, useState } from 'react';
import { isBrowser, isMobile } from 'react-device-detect';

function AppTour() {
  const steps: any[] = useStore<EditorStore, any>('tourStepsRef')[0];
  const [stepsComponent, setStepsComponent] = useState<any[]>([]);
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    if (steps.some((item) => !item.ref) || isMobile) {
      return;
    }

    setTimeout(() => {
      const componentList = steps.map((item) => (
        <StepTourPopover
          refElement={item.ref}
          key={item.index}
          content={item.content}
          positionPopper={item.positionPopper}
          positionPopover={item.positionPopover}
        />
      ));

      setStepsComponent(componentList);
    }, 100);
  }, [steps]);

  useEffect(() => {
    if (steps.some((item) => !item.ref) || isBrowser) {
      return;
    }

    setTimeout(() => {
      const componentList = steps
        .filter((item) => item.index === currentStep)
        .map((item) => (
          <StepTourPopover
            onCurrentStep={setCurrentStep}
            refElement={item.ref}
            key={item.index}
            content={item.content}
            positionPopper={item.positionPopper}
            positionPopover={item.positionPopover}
          />
        ));

      setStepsComponent(componentList);
    }, 100);
  }, [steps, currentStep]);

  return <>{stepsComponent}</>;
}

export default AppTour;
